import { ToggleOptions } from '../ToggleOptions';

const thresholdTitle = 'Rewards Threshold';
const thresholdDescription = 'Activate reward thresholds and specify how many customer votes your team members need before they become eligible for the rewards you have chosen.';

export function RewardsThreshold({ value, onChange }: RewardsThresholdProps) {
  const thresholdOptions = [
    { id: 'enable', text: 'Yes', value: true },
    { id: 'disable', text: 'No', value: false },
  ];

  return (
    <ToggleOptions
      title={thresholdTitle}
      value={value}
      options={thresholdOptions}
      description={thresholdDescription}
      onChange={newValue => onChange(newValue)}
    />
  );
}

interface RewardsThresholdProps {
  value: boolean;
  onChange: (isEnabled: boolean) => void;
}
